import React from "react";
import monthsObj from "./months";

const ChevronLeft = () => (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path fillRule="evenodd" d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z" clipRule="evenodd" />
  </svg>
);

const ChevronRight = () => (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path fillRule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
  </svg>
);

const ChevronDown = () => (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path fillRule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0l-4.25-4.25a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
  </svg>
);

export default class DatePicker extends React.Component {
  state = {
    selectedMonth: new Date().toUTCString().toString().split(" ")[2],
    year: new Date().getFullYear(),
    isOpen: false,
  };

  // Update state when parent date changes (for navigation from locked expenses)
  componentDidUpdate(prevProps) {
    if (this.props.currentDate && this.props.currentDate !== prevProps.currentDate) {
      // Parse "MM-YYYY" format
      const dateParts = this.props.currentDate.split("-");
      const month = dateParts[0];
      const year = parseInt(dateParts[1], 10);
      
      // Convert month number to month name
      const monthName = monthsObj.months[parseInt(month, 10) - 1];
      
      if (monthName && (this.state.selectedMonth !== monthName || this.state.year !== year)) {
        this.setState({
          selectedMonth: monthName,
          year: year,
        });
      }
    }
  }
  render() {
    const selectedLabel = `${this.state.selectedMonth} ${this.state.year}`;
    const months = monthsObj.months.slice(0, 12);

    return (
      <div className="relative inline-flex items-center gap-1 text-sm text-white">
        <button
          type="button"
          className="-m-1.5 flex items-center justify-center p-1.5 text-white/70 hover:text-white"
          onClick={() => this.onChangeMonthHandler("sub")}
          aria-label="Previous month"
        >
          <ChevronLeft />
        </button>

        <button
          type="button"
          className="flex items-center gap-1 px-3 py-1.5 text-sm font-semibold text-white hover:text-white/80"
          onClick={this.showHideCalendar}
          aria-haspopup="dialog"
          aria-expanded={this.state.isOpen}
        >
          <span>{selectedLabel}</span>
          <ChevronDown />
        </button>

        <button
          type="button"
          className="-m-1.5 flex items-center justify-center p-1.5 text-white/70 hover:text-white"
          onClick={() => this.onChangeMonthHandler("add")}
          aria-label="Next month"
        >
          <ChevronRight />
        </button>

        {this.state.isOpen && (
          <div className="absolute left-1/2 top-full z-50 mt-2 w-64 -translate-x-1/2 rounded-lg bg-white p-4 text-gray-900 shadow-lg ring-1 ring-gray-900/5">
            <div className="flex items-center justify-between">
              <button
                type="button"
                className="-my-1.5 flex items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
                onClick={() => this.onChageYearHandler("min")}
                aria-label="Previous year"
              >
                <ChevronLeft />
              </button>
              <span className="text-sm font-semibold text-gray-900">{this.state.year}</span>
              <button
                type="button"
                className="-my-1.5 flex items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
                onClick={() => this.onChageYearHandler("plus")}
                aria-label="Next year"
              >
                <ChevronRight />
              </button>
            </div>
            <div className="mt-4 grid grid-cols-3 gap-1 text-center text-sm">
              {months.map((month) => {
                const isSelected = month === this.state.selectedMonth;
                return (
                  <button
                    key={month}
                    type="button"
                    onClick={() => this.onClickMonth(month)}
                    className={`rounded-md py-2 font-medium ${
                      isSelected
                        ? "bg-indigo-600 text-white"
                        : "text-gray-900 hover:bg-gray-100"
                    }`}
                  >
                    {month}
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
  onClickMonth = (month) => {
    const dateForFetch =
      monthsObj.indexConvert2[month] + "-" + this.state.year;
    this.props.selectDateHandler(dateForFetch);
    this.setState({
      selectedMonth: month,
    });
    this.showHideCalendar();
  };
  showHideCalendar = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };
  onChageYearHandler = (type) => {
    let nextYear = this.state.year;
    if (type === "min") nextYear--;
    if (type === "plus") nextYear++;
    const dateForFetch =
      monthsObj.indexConvert2[this.state.selectedMonth] + "-" + nextYear;
    this.props.selectDateHandler(dateForFetch);
    this.setState({
      year: nextYear,
    });
  };
  onChangeMonthHandler = (type) => {
    const currentIndex = monthsObj.months.indexOf(this.state.selectedMonth);
    let nextIndex = currentIndex;
    let nextYear = this.state.year;
    if (type === "sub") {
      nextIndex--;
      if (nextIndex < 0) {
        nextIndex = 11;
        nextYear--;
      }
    }
    if (type === "add") {
      nextIndex++;
      if (nextIndex > 11) {
        nextIndex = 0;
        nextYear++;
      }
    }
    const nextMonth = monthsObj.months[nextIndex];
    const dateForFetch = monthsObj.indexConvert2[nextMonth] + "-" + nextYear;
    this.props.selectDateHandler(dateForFetch);
    this.setState({
      year: nextYear,
      selectedMonth: nextMonth,
    });
  };
}
